/* Dashboard services */

import { API } from '../../Services/Api';
// import {log} from '@craco/craco/lib/logger'

const request = new API();

export const getDashboardFiltersOptions = (params) => request.api.get(`/dashboard/filters/`, params);
export const getApiKeyOptions = () => request.api.get(`/dashboard/apikey/`);

export const getDashboardCharts = (params) => {
  if (params?.period_preset) {
    delete params?.period_preset
  }
  // if (params?.entity === 'scores') {
  //   delete params?.search
  //   delete params?.filter
  // }
  return request.api.get(`/dashboard/charts/`, params);
};

export const getDashboardInfo = (params) => {
  if (params?.period_preset) {
    delete params?.period_preset
  }
  return request.api.get(`/dashboard/table-events/`, params);
};

export const getDashboardEventsTableColumns = () => {
  return request.api.get(`/dashboard/table-events/columns/`);
};

export const getDashboardDateRefresh = () => {
  return request.api.get(`/dashboard/refresh-date/`);
};

export const getDashboardEventDetailsInfo = (params) => {
  return request.api.get(`/dashboard/table-events/details/`, params);
};

export const getNextDashboardInfo = ({ link }) => {
  // The pagination cursor comes from the API. Resolve it against the API base
  // and refuse anything that would send the bearer token to another origin.
  const base = new URL(process.env.REACT_APP_BASE_API_ROUTE);
  let uri;
  try {
    uri = new URL(process.env.REACT_APP_BASE_API_ROUTE + String(link || ''));
  } catch (e) {
    uri = null;
  }
  // Match the base path as a whole segment, so '/api-admin' or '/api.x' do not pass.
  const basePath = base.pathname.replace(/\/+$/, '');
  const underBase = uri && (uri.pathname === basePath || uri.pathname.startsWith(basePath + '/'));
  if (!uri || uri.protocol !== base.protocol || uri.host !== base.host || uri.username || uri.password || !underBase) {
    return Promise.resolve({ ok: false, problem: 'CLIENT_ERROR', data: { error: 'Invalid pagination link' } });
  }
  return request.api.get(uri.href, null);
};

export const getTermsStatus = (data) => {
  return request.api.post(`/auth/toc-accepted`, data);
};
